import { Injectable } from '@angular/core';
import { IFooter } from 'src/app/api/modules/core/components/static/IFooter';
import { FooterRepository } from './footer.repository';

/**
 * The FooterService is used to publically update the {@link FooterStore}.
 */
@Injectable({
  providedIn: 'root',
})
export class FooterService {
  /**
   * Constructor
   */
  constructor(private readonly footerRepository: FooterRepository) {}

  /**
   * Initialize the Footer.
   *
   * @param configuration - the configuration
   */
  initialize(configuration?: IFooter) {
    this.applyConfiguration(configuration);
  }

  /**
   * Apply a configuration to the Footer.
   *
   * @param configuration - the configuration
   */
  applyConfiguration(configuration?: IFooter) {
    this.footerRepository.applyConfiguration(configuration);
  }
}
